import { getRange, setRange } from "./selectionRange";

export const getCurrentSelectionPosition = parentElement => {
  return getRange(parentElement);
};

export const setCurrentSelectionPosition = (selectionPosition, element) => {
  return setRange(element, selectionPosition);
};
